// frontend/src/Components/SyncTo/helpers/userIdFromJwt.js
// Phase 30 — userId for IDB scoping (invariant #7 / PITFALLS #6).
// This is a LABEL, not a security gate — backend middleware is the real gate.
// Defensive read `_id || id` per Assumption A5 (30-RESEARCH.md).

import { jwtDecode } from 'jwt-decode';

export function readUserIdFromJwt() {
  try {
    const token = sessionStorage.getItem('user');
    if (!token) return null;
    const decoded = jwtDecode(token);
    return decoded?._id || decoded?.id || null;
  } catch {
    return null;
  }
}
